import React from 'react';
import { Briefcase, MapPin, Calendar } from 'lucide-react';
import { experience } from '../data/mock';

const Experience = () => {
  return (
    <section id="experience" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-blue-500">Experience</span>{' '}
            <span className="text-red-500">Timeline</span>
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-red-500 mt-4 mx-auto rounded-full"></div>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-[19px] top-0 bottom-0 w-1 bg-gray-200 rounded-full"></div>

          {/* Experience Items */}
          <div className="space-y-12">
            {experience.map((exp, index) => {
              const colors = [
                { dot: 'bg-blue-500', text: 'text-blue-600', bg: 'bg-blue-100' },
                { dot: 'bg-red-500', text: 'text-red-600', bg: 'bg-red-100' },
                { dot: 'bg-yellow-500', text: 'text-yellow-600', bg: 'bg-yellow-100' },
                { dot: 'bg-green-500', text: 'text-green-600', bg: 'bg-green-100' },
                { dot: 'bg-purple-500', text: 'text-purple-600', bg: 'bg-purple-100' }
              ];
              const color = colors[index % colors.length];

              return (
                <div key={exp.id} className="relative flex gap-8">
                  {/* Timeline Dot */}
                  <div className="mt-1 flex-shrink-0 z-10">
                    <div className={`w-10 h-10 rounded-full border-[3px] border-gray-800 ${color.bg} flex items-center justify-center`}>
                      <div className={`w-4 h-4 rounded-full ${color.dot}`}></div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 pt-1">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
                      <h3 className="text-2xl font-bold text-gray-900">
                        {exp.role} <span className={`${color.text}`}>@{exp.company}</span>
                      </h3>
                    </div>

                    <div className="flex flex-wrap gap-x-4 gap-y-2 text-sm text-gray-600 mb-4 font-medium">
                      <span>{exp.period}</span>
                      <span>|</span>
                      <span>{exp.location}</span>
                    </div>

                    <ul className="space-y-2">
                      {exp.highlights.map((highlight, idx) => (
                        <li key={idx} className="text-gray-700 text-base leading-relaxed">
                          {highlight}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;